
// 根据环境设置baseURL
const getBaseURL = () => {
  // 检查是否有环境变量
  if (process.env.VUE_APP_BASE_API) {
    return process.env.VUE_APP_BASE_API
  }
  
  // 根据环境返回不同的API地址
  if (process.env.NODE_ENV === 'development') {
    return 'http://192.168.0.199:8999'
  } else {
    return 'https://jiemeet2.w.jjiegeng.cn'
  }
}

// 导出API配置
export const apiConfig = {
  baseURL: getBaseURL(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  },
  retry: 2,
  retryDelay: 1000
}

// export default config 